import { registerLocaleData } from '@angular/common';
import { Injectable } from '@angular/core';
import localeBr from '@angular/common/locales/pt';
import localeEsPy from '@angular/common/locales/es-PY';
import localeEn from '@angular/common/locales/en';
import { CurrencyMaskConfig } from 'ngx-currency';
import { CountryContextService } from './countryContext.service';
import { TranslationService } from '..';

@Injectable({
    providedIn: 'root',
})
export class LocaleService {
    constructor(private translationService: TranslationService, private countryContextService: CountryContextService) {}

    get getCurrencyMaskConfig(): CurrencyMaskConfig {
        return {
            align: 'right',
            allowNegative: true,
            allowZero: true,
            decimal: ',',
            precision: this.decimalDigitSelected,
            prefix: this.getCurrencySelected,
            suffix: '',
            thousands: '.',
            nullable: false,
        };
    }

    get decimalDigitSelected(): number {
        return this.countryContextService.languageSelected?.decimalDigits;
    }

    get countryCodeSelected(): string {
        return this.countryContextService.languageSelected?.code;
    }

    get getCurrencySelected(): string {
        return this.countryContextService.languageSelected?.currency;
    }
    private registerAllLanguages() {
        registerLocaleData(localeEn);
        registerLocaleData(localeEsPy);
        registerLocaleData(localeBr);
    }

    public initLanguage(): string {
        this.registerAllLanguages();
        this.translationService.setBycontext();
        let code = this.countryCodeSelected;
        return code;
    }
}
